import styled from 'styled-components'
import { Style } from '../../styles'

const Header = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 16px;
	padding-right: 24px;
	border-bottom: 1px solid ${Style.color.border};

	@media screen and (max-width: ${Style.breakpoints.SMALL}) {
		border-top: 1px solid ${Style.color.border};
	}
`

export default Header